import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { combineLatest, Observable, Subject } from 'rxjs';
import { repeat, takeUntil, tap } from 'rxjs/operators';
import { tags } from './../../../../../../_shared/constants/customTags.const';
import { DATE_CONST } from './../../../../../../_shared/constants/date-constants.const';
import { EventActions } from './../../../../../../_shared/enums/eventActions.enum';
import { PortfolioPaper } from './../../../../../../_shared/model/portfolio/portfolioPaper.model';
import { EmptySlot } from './../../../../../../_shared/model/schedule/empty-slot.model';
import { EventReturn } from './../../../../../../_shared/model/schedule/eventReturn.model';
import { TreatmentGuiList } from './../../../../../../_shared/model/treatment/treatment-gui-list.model';
import { TreatmentNote } from './../../../../../../_shared/model/treatment/treatment-notes.model.';
import { TreatmentGUI } from './../../../../../../_shared/model/treatment/treatmentGUI.model';
import { TreatmentReservationRequest } from './../../../../../../_shared/model/treatment/treatmentReservationRequest';
import { HelperService } from './../../../../../../_shared/services/helper.service';
import { MfToastService } from './../../../../../../_shared/services/mfToast.service';
import { Notes, Term, TreatmentActions } from './../../../../../../_shared/state/treatment/treatment.actions';
import { TreatmentState } from './../../../../../../_shared/state/treatment/treatment.state';
import { MainCalendarPopupComponent } from './../../../main-calendar/main-calendar-popup/main-calendar-popup.component';
import { PfType } from './../../../portfolio-papers/_common/enum/pf-type.enum';

@Component({
    selector: 'app-trt-wid-main-popup',
    templateUrl: './trt-wid-main-popup.component.html',
    styleUrls: ['./trt-wid-main-popup.component.scss'],
})
export class TrtWidMainPopupComponent implements OnInit {
    // public termItems: TreatmentReservationRequest[] = [];
    // public termItems$: Observable<TreatmentReservationRequest[]>;
    public termItems$: Observable<TreatmentGuiList[]>;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public termItems2$: Observable<any[]>;
    public portfolioPapers: PortfolioPaper[];
    public resRequestData: TreatmentGUI;
    public isSubmited: boolean;
    public treatmentDetailsForm: FormGroup;
    // public termGeneratorForm: FormGroup;
    public pfType = PfType;
    public itemForm: FormGroup;
    public isLoaded = false;
    public isGeneratorLoaded = false;
    private onDestroy$ = new Subject<void>();

    constructor(
        public activeModal: NgbActiveModal,
        private store: Store,
        private modalService: NgbModal,
        private fb: FormBuilder,
        private toast: MfToastService,
        private helper: HelperService,
    ) {}

    ngOnInit() {
        // this.termItems$ = this.store.select(TreatmentState.allTermsAndNotes).pipe(takeUntil(this.onDestroy$));

        this.store.dispatch([new TreatmentActions.LoadTreatmentPortfolio()]).pipe(takeUntil(this.onDestroy$)).subscribe();

        this.store
            .select(TreatmentState.portfolioPapers)
            .pipe(
                takeUntil(this.onDestroy$),
                tap(data => {
                    this.portfolioPapers = _.cloneDeep(data);
                }),
            )
            .subscribe();
        // this.termItems$ = this.store.select(TreatmentState.allTerms).pipe(takeUntil(this.onDestroy$));
        this.store
            .select(TreatmentState.treatmentData)
            .pipe(
                tap(resRequestData => (this.resRequestData = resRequestData)),
                takeUntil(this.onDestroy$),
            )

            .pipe(takeUntil(this.onDestroy$))
            .subscribe();
        this.createTreatmentDetailsForm();
        this.createItemForm();
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public createItemForm(): void {
        this.itemForm = this.fb.group({
            test: new FormControl(),
            items: this.fb.array([]),
        });

        combineLatest([this.store.select(TreatmentState.allTerms), this.store.select(TreatmentState.allNotes)])
            .pipe(takeUntil(this.onDestroy$))
            .pipe(
                tap(([terms, notes]) => {
                    const genGroup: FormGroup[] = [];
                    (<FormArray>this.itemForm.controls.items).clear();
                    terms?.map(el => {
                        genGroup.push(this.generateTermItem(el));
                        // (<FormArray>this.itemForm.controls.items).push(this.generateTermItem(el));
                    });

                    notes?.map(el => {
                        genGroup.push(this.generateNoteItem(el));
                        // (<FormArray>this.itemForm.controls.items).push(this.generateNoteItem(el));
                    });
                    genGroup.sort((a: FormGroup, b: FormGroup) => {
                        let result = 1;
                        let a1;
                        let b1;
                        if (a?.value.itemType == 'NOTE') {
                            a1 = moment(a?.value.eventDate, DATE_CONST.format.date.view);
                        } else {
                            a1 = a?.value.selectedDate;
                        }

                        if (b?.value.itemType == 'NOTE') {
                            b1 = moment(b?.value.eventDate, DATE_CONST.format.date.view);
                        } else {
                            b1 = b?.value.selectedDate;
                        }

                        if (moment(a1).isSameOrBefore(moment(b1))) {
                            result = -1;
                        }
                        return result;
                    });
                    genGroup.forEach(el => (<FormArray>this.itemForm.controls.items).push(el));
                    // genGroup.sort()
                }),
            )
            .subscribe(() => (this.isLoaded = true));
    }
    public identify(index, item) {
        if (item.internalId) {
            return item.internalId;
        }
        return item.treatmentResId;
    }

    public onClosePopup(): void {
        this.store
            .select(TreatmentState.treatmentData)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((trt: TreatmentGUI) => {
                if (trt?.isTreatmentCreated) {
                    const retData: EventReturn = new EventReturn().deserialize({
                        action: EventActions.RELOAD,
                    });
                    this.activeModal.dismiss(retData);
                } else {
                    this.activeModal.dismiss();
                }
            });
        // this.store.dispatch(new ClearTreatmentState());
    }

    public addOneNewTerm(): void {
        // this.store
        //     .dispatch(
        //         new Term.AddNewTerm(
        //             new GenTreatmentFormData().deserialize({
        //                 recurringType: RecurringType.WEEKLY,
        //                 recurringFrequency: 1,
        //                 // termType: data.termType.reservationType,
        //             }),
        //         ),
        //     )
        //     .pipe(repeat(1))
        //     .subscribe();
    }

    public addTermFromCalendar(): void {
        const modalTermCalendar = this.modalService.open(MainCalendarPopupComponent, { size: 'lg' });
        modalTermCalendar.result.then(
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => {},
            (emptySlot: EmptySlot) => {
                if (emptySlot?.startDate) {
                    this.store.dispatch(new Term.AddNewTerm(emptySlot)).pipe(repeat(1)).subscribe();
                }
            },
        );

        // modalTermCalendar.componentInstance.selectedCustomerForNewTerm = row?.customer;
        // modalTermCalendar.componentInstance.limitToSubcontractors = [];

        modalTermCalendar.componentInstance.isGetOnlySlot = true;
        modalTermCalendar.componentInstance.canOpenTerm = false;
    }

    public addTreatmentEvent(): void {
        this.store.dispatch(new Notes.AddNewNote()).pipe(repeat(1)).subscribe();
    }

    public createTreatment(): void {
        this.isSubmited = true;
        if (this.treatmentDetailsForm.valid) {
            this.isSubmited = false;
            this.store.dispatch(new TreatmentActions.CreateNewTreatment()).subscribe(
                () => {
                    // this.treatmentDetailsForm.disable();
                },
                () => {
                    this.toast.error('Napaka pri kreiranju zravljenja.');
                },
            );
        }
    }

    public updateReservationsTreatment(): void {
        //bookiramo vse termine, ki so na novo generirani
        this.store.dispatch([new TreatmentActions.UpdateReservationsTreatment(), new TreatmentActions.UpdateNotesTreatment()]);
    }

    private createTreatmentDetailsForm(): void {
        // https://www.ngxs.io/plugins/form
        // if (!this.treatmentDetailsForm) {
        this.treatmentDetailsForm = this.fb.group({
            id: this.fb.control({ value: '' }),
            description: this.fb.control({ value: '' }, Validators.required),
            customer: this.fb.control({ value: '' }, Validators.required),
            smsNotify: this.fb.control({ value: '' }),
            emailNotify: this.fb.control({ value: '' }),
        });
    }

    public showTermGenerator(): void {
        this.store.dispatch(new Term.InitTermGenerator());
        this.isGeneratorLoaded = true;
    }

    private generateTermItem(item: TreatmentReservationRequest): FormGroup {
        return this.fb.group({
            // treatmentResId: this.fb.control({ value: item.treatmentResId, disabled: false }, Validators.required),
            selectedSubcontractor: this.fb.control({ value: item.selectedSubcontractor, disabled: false }, Validators.required),
            selectedDate: this.fb.control(
                {
                    value: _.get(item, 'selectedDate', moment()),
                    disabled: false,
                },
                Validators.required,
            ),
            selectedDateView: this.fb.control(
                {
                    value: _.get(item, 'selectedDate', moment()).format('DD.MM.YYYY'),
                    disabled: false,
                },
                Validators.required,
            ),
            selectedTime: this.fb.control({ value: item.selectedTime, disabled: item.disableDateChange }, Validators.required),
            selectedTimeEnd: this.fb.control({ value: item.selectedTimeEnd, disabled: item.disableDateChange }, Validators.required),
            selectedService: this.fb.control({ value: item.selectedService, disabled: false }, Validators.required),
            selectedAsset: this.fb.control({ value: item.selectedAsset, disabled: false }, Validators.required),

            customTagId: this.fb.control({
                value: item.customTagId ? tags.CUSTOM_TERMS_TAGS_OBJ[item.customTagId] : tags.CUSTOM_TERMS_TAGS_OBJ[1],

                disabled: false,
            }),
            termType: this.fb.control({
                value: item.termTypeObj | tags.TERM_TYPE.obj.RESERVATION.id,
                disabled: false,
            }),
            internalId: this.fb.control({ value: item?.internalId || this.helper.uuid(), disabled: false }),
            isDetailsOpend: this.fb.control({ value: item?.isDetailsOpend || false, disabled: false }),
            itemType: this.fb.control({ value: 'TERM', disabled: false }),
            availabilityStatus: this.fb.control({ value: item?.availabilityStatus, disabled: false }),
            prereservationId: this.fb.control({ value: item?.prereservationId, disabled: false }),
            freeSlots: this.fb.control({ value: item?.freeSlots, disabled: false }),
        });
    }

    private generateNoteItem(item: TreatmentNote): FormGroup {
        return this.fb.group({
            itemType: this.fb.control({ value: 'NOTE', disabled: false }),
            internalId: this.fb.control({ value: item?.internalId, disabled: false }),
            id: this.fb.control({ value: item?.id, disabled: false }),
            title: this.fb.control({ value: item?.title, disabled: false }, Validators.required),
            content: this.fb.control({ value: item?.content, disabled: false }),
            eventDate: this.fb.control({ value: item?.eventDate.format(DATE_CONST.format.date.view), disabled: false }, Validators.required),
            documents: this.fb.control({ value: item?.documents || [], disabled: false }),
            isDetailsOpend: this.fb.control({ value: item?.isDetailsOpend || false, disabled: false }),
            availabilityStatus: this.fb.control({ value: item?.availabilityStatus, disabled: false }),
        });
    }

    public onCloseGenerator(): void {
        this.isGeneratorLoaded = false;
    }
}
